<div class="container">
   <div class="row justify-content-center">
      <div class="col-12 col-md-6 col-lg-5">
         <form [formGroup]="searchForm" (ngSubmit)="search()" novalidate>
            <fieldset [disabled]="accountSearchIsLoading()" class="border-0 p-0 m-0">

               <div class="mb-3"
                    [class.error]="partnerRepSourceId.invalid && (partnerRepSourceId.dirty || partnerRepSourceId.touched)">
                  <label for="partnerRepSourceId" class="form-label fw-bold">Dealer Account Number</label>
                  @if(partnerRepSourceId.invalid && (partnerRepSourceId.dirty || partnerRepSourceId.touched)){
                  <em class="error-msg-block mb-1">
                     Enter valid Account Number
                  </em>
                  }
                  <input type="text"
                         id="partnerRepSourceId"
                         class="form-control"
                         formControlName="partnerRepSourceId"
                         maxlength="8"
                         autocomplete="off" />
               </div>

               <!--<div class="mb-3 fw-bold fst-italic">
                  <h1>~ AND/OR ~</h1>
               </div>-->

               <div class="mb-3"
                    [class.error]="subscriptionReferenceSourceId.invalid && (subscriptionReferenceSourceId.dirty || subscriptionReferenceSourceId.touched)">
                  <label for="subscriptionReferenceSourceId" class="form-label fw-bold">Remittance Number</label>
                  @if(subscriptionReferenceSourceId.invalid && (subscriptionReferenceSourceId.dirty || subscriptionReferenceSourceId.touched)){
                  <em class="error-msg-block mb-1">
                     Enter valid remittance number
                  </em>
                  }
                  <input type="text"
                         id="subscriptionReferenceSourceId"
                         class="form-control"
                         maxlength="10"
                         formControlName="subscriptionReferenceSourceId"
                         autocomplete="off" />
               </div>

               @if (searchForm.errors?.['atLeastOneRequired'] && (searchForm.touched || searchForm.dirty)) {
               <div class="alert alert-danger py-2">
                  Please enter a Dealer Account Number or a Remittance Number.
               </div>
               }

               <div class="d-grid">
                  <button type="submit"
                          class="btn btn-primary"
                          [disabled]="searchForm.invalid || accountSearchIsLoading()">
                     Search
                  </button>
               </div>

            </fieldset>
         </form>
      </div>
   </div>

   @if (accountSearchIsLoading()) {
   <div class="d-flex justify-content-center mt-4">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
         <span class="visually-hidden">Loading...</span>
      </div>
   </div>
   } @else if (accountSearchErrorMessage()) {
   <div class="alert alert-danger mt-4" role="alert">
      <strong>Unable to load subscriptions.</strong>
      <div class="small">{{ accountSearchErrorMessage() }}</div>
   </div>
   } @else if (accountSearchResults.value().length) {
      <div class="row g-3 mt-1">
         @for(accountSearchResult of accountSearchResults.value(); track accountSearchResult.id) {
         <div class="col-12 col-md-6 col-xl-4">
            <div class="subscription-card h-100"
                 role="button"
                 tabindex="0"
                 (click)="goToAccountDetail(accountSearchResult.info?.safeId)"
                 (keydown.enter)="goToAccountDetail(accountSearchResult.info?.safeId)"
                 (keydown.space)="goToAccountDetail(accountSearchResult.info?.safeId)">
            <app-account-card [actionableSubscription]="accountSearchResult.info.actionableSubscription" [emailAsLink]="false" />
            </div>
         </div>
         }
      </div>
   } @else if (accountSearchHasCriteria()) {
   <p class="text-error mb-0 fw-bold text-center mt-4"><em>* No results matching your criteria *</em></p>
   }

   <!--<div class="mt-4">{{user()|json}}</div>-->
   <!--$any(info.actionableSubscription).statusDescription-->
</div>
